import {useConstant, useForceUpdate} from '@sail/engine';
import {useEffect} from 'react';

export default function useCurrentBreakpoints() {
  const queries = useConstant(() => {
    return {
      mobile: window.matchMedia('(max-width: 600px)'),
      tablet: window.matchMedia('(min-width: 601px) and (max-width: 1024px)'),
      desktop: window.matchMedia('(min-width: 1025px) and (max-width: 1450px)'),
      widescreen: window.matchMedia('(min-width: 1451px)'),
    };
  });

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const values = Object.values(queries);
    values.forEach((mq) => mq.addEventListener('change', forceUpdate));
    return () =>
      values.forEach((mq) => mq.removeEventListener('change', forceUpdate));
  }, [forceUpdate, queries]);

  return Object.entries(queries)
    .filter((entry) => entry[1].matches)
    .map(([key]) => key);
}

export function useIsMobileBreakpoints() {
  const currentBreakpoints = useCurrentBreakpoints();
  return currentBreakpoints.includes('mobile');
}
